import React, { useEffect } from "react";
import { Checkbox, Col, Divider, Form, Row } from "antd";
import { CustomModal } from "../../components/styledComponent/styledModal";
import {
  StyledButton,
  StyledInput,
  StyledPasswordInput,
} from "../../components/styledComponent/styledElements";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { Capitalize } from "../../utils/utils";
import { useAppContext } from "../../contexts/appContext";
import { getStaffDetails, updateStaff } from "../../server/staffServices";
import { ShowNotification } from "../../components/notification/notification";

const StaffCreationModal = ({
  showCreationModal = false,
  setShowCreationModal,
  onSubmit,
  formRef,
  updateId,
  setUpdate = () => {},
  setRefetch,
}) => {
  const { startLoading, stopLoading } = useAppContext();

  const onSubmitForm = () => {
    formRef.current.submit();
  };
  const onCancelForm = () => {
    formRef.current.resetFields();
    setShowCreationModal(false);
    setUpdate(null);
  };
  const permissionName = [
    "banner",
    "category",
    "customer",
    "product",
    "purchase_order",
    "quotation",
    "staff",
    "import",
  ];
  const fetchStaffDetails = async () => {
    startLoading();
    try {
      let res = await getStaffDetails(updateId);
      formRef.current.setFieldsValue({ ...res.data });
    } catch (error) {
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    if (updateId) {
      fetchStaffDetails();
    }
  }, []);
  const handleUpdateStaff = (values) => {
    startLoading();
    updateStaff(updateId, values)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Staff Updated Successfully",
        });
        setShowCreationModal(false);
        setUpdate(null);
        setRefetch(true);
        setShowCreationModal(false);
        formRef.current.resetFields();
      })
      .finally(() => {
        stopLoading();
      });
  };
  const PermissionGroup = ({ permissionName }) => (
    <Col span={8}>
      <h3>{Capitalize(permissionName)} Permissions</h3>
      {["view", "create", "edit", "delete"].map((action) => (
        <Form.Item
          key={action}
          name={["access", permissionName, action]}
          valuePropName="checked"
          noStyle
          initialValue={action === "view" ? true : false}
        >
          <Checkbox className="mr-1" style={{ marginBottom: 8 }}>
            {action.charAt(0).toUpperCase() + action.slice(1)}
          </Checkbox>
        </Form.Item>
      ))}
    </Col>
  );
  return (
    <CustomModal
      title={updateId ? "Update Staff Details" : "Add Staff"}
      open={showCreationModal}
      onClose={onCancelForm}
      onCancel={onCancelForm}
      okText={"Add"}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancelForm}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onSubmitForm}>
          {updateId ? "Update" : "Save"}
        </StyledButton>,
      ]}
    >
      <Divider className="mt-0" />
      <Form
        ref={formRef}
        layout="vertical"
        onFinish={updateId ? handleUpdateStaff : onSubmit}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter name !" }]}
            >
              <StyledInput width={"100%"} placeholder="Enter Fullname" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Contact Number"
              name="contact_no"
              rules={[{ required: true, message: "Please enter contact no.!" }]}
            >
              <StyledInput
                type="number"
                placeholder="Enter Contact number"
                width={"100%"}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email Id"
              name="email"
              rules={[{ required: true, message: "Please enter email id !" }]}
            >
              <StyledInput
                placeholder="example@mail.com"
                width={"100%"}
                disabled={updateId ? true : false}
              />
            </Form.Item>
          </Col>
          {!updateId && (
            <Col span={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Please enter password !" }]}
              >
                <StyledPasswordInput placeholder="Password" width={"100%"} />
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item
              label="Address"
              name="address"
              rules={[
                { required: true, message: "Please enter staff address!" },
              ]}
            >
              <StyledInput placeholder="Enter Address" width={"100%"} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <StyledContentCard subTitle={"Set staff permission"}>
              <Row gutter={16}>
                {permissionName.map((value) => {
                  return <PermissionGroup permissionName={value} />;
                })}
              </Row>
            </StyledContentCard>
          </Col>
        </Row>
      </Form>
    </CustomModal>
  );
};

export default StaffCreationModal;
